<template>
  <nav class="breadcrumb">
    <a
      href="javascript:void(0);"
      @click="
        btnCmd('routerPush', {
          path: homeLink,
          query: {},
        })
      "
      class="home"
    >
      <i class="c-icon icon-home"></i>
      <span class="sr-only">홈</span>
    </a>
    <template v-for="(item, index) in breadcrumbs" :key="index">
      <!-- <div v-if="item.path == null || item.path === ''" class="page">
        &nbsp;>&nbsp;{{ item.name }}
      </div> -->
      <a
        v-if="item.path == null || item.path === ''"
        href="javascript:(0);"
        :aria-current="index === breadcrumbs.length - 1 ? 'page' : undefined"
        class="page"
        >{{ item.name }}</a
      >
      <a
        href="javascript:void(0);"
        v-else
        @click="
          btnCmd('routerPush', {
            path: item.path,
            query: {},
          })
        "
        :aria-current="index === breadcrumbs.length - 1 ? 'page' : undefined"
        class="page"
        >{{ item.name }}</a
      >
    </template>
  </nav>
</template>

<script setup name="breadCrumb">
import { defineProps } from "vue";

import { useRouter } from "vue-router";
const router = useRouter();

defineProps({
  homeLink: {
    type: String,
    default: "/paintpro/main",
  },
  breadcrumbs: {
    type: Array,
    required: true,
  },
});

/**********************
 * 버튼 클릭 모음
 *********************/
async function btnCmd(cmd = "", parms = {}) {
  if (cmd === "routerPush") {
    router.push({
      path: parms.path,
      query: parms.query,
    });
  } else {
    alert(`[개발확인] btnCmd() cmd [${cmd}] 를 확인해주세요` + parms);
    return false;
  }
}
</script>
